// FullScreenLoader.jsx

const FullScreenLoader = () => {
  return (
    <div className="fullscreen-loader">
      <div className="spinner-border text-primary" />
    </div>
  );
};

export default FullScreenLoader;